export default __webpack_public_path__ + "static/media/E03.1a71598b.mp3";